export default __webpack_public_path__ + "static/media/2294.a35913f0.png";